import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {AlertService, AuthenticationService, ComplianceAreaService, ControlItemsService} from '../../_services/index';

import {ComplianceArea} from '../../_models/index';

import {LoginHelper} from '../../helpers/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";

@Component({
    standalone: false,
  selector: 'control-item-component',
  templateUrl: 'mapControlItems.html',
  styleUrls: ['./mapControlItems.css'],
})

export class MapControlItemsComponent implements OnInit {
  loading = false;
  complianceAreas: ComplianceArea[];
  tenantName: string;
  complianceAreaId: number;
  complianceArea: ComplianceArea;
  rowGroupMetadata: {};
  cols : any[] = [
    {field: 'category', header: 'Current Compliance Area'},
  ];

  constructor(
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public controlItemsService: ControlItemsService,
    public complianceAreaService: ComplianceAreaService) {
    this.complianceAreaId = route.snapshot.params['complianceAreaId'];
  }

  ngOnInit() {

    this.tenantName = LoginHelper.getTenantName();
    if (this.tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.load();
  }

  load() {
    this.complianceAreaService.getComplianceAreas().subscribe(areas => {
      this.controlItemsService.getAll().subscribe(controlItems => {
        areas.forEach(a => {
          a.controlItems = controlItems.filter(c => c.complianceAreaId == a.complianceAreaId)/*.sort((a, b) => {
            return a.category > b.category ? 1 : a.category < b.category ? -1 : a.complianceAreaControlId > b.complianceAreaControlId ? 1 : -1;
          })*/;
        });
        let map = {};
        controlItems.forEach(p => map[p.controlItemId] = p);
        areas.forEach(a => {
          a.controlItems.forEach(p => {
            if (p.broadcastControlItemId) {
              map[p.broadcastControlItemId].broadcastTargets = map[p.broadcastControlItemId].broadcastTargets || {};
              map[p.broadcastControlItemId].broadcastTargets[p.complianceAreaId] = map[p.broadcastControlItemId].broadcastTargets[p.complianceAreaId] || [];
              map[p.broadcastControlItemId].broadcastTargets[p.complianceAreaId].push(p);
            }
          });
        });
        this.complianceAreas = areas;
        const current = areas.find(p => p.complianceAreaId == this.complianceAreaId);
        this.complianceArea = current;
        this.complianceAreas = this.complianceAreas.filter(p => p.complianceAreaId != this.complianceAreaId);
        this.updateRowGroupMetaData();
      });
    })
  }

  deletePair(item) {
    const updated = (this.complianceAreas.find(i => i.complianceAreaId == item.complianceAreaId) || this.complianceArea).controlItems.find(i => i.controlItemId == item.controlItemId);
    updated.broadcastControlItemId = null;
    updated.tenantName = this.tenantName;
    this.controlItemsService.update(updated, this.tenantName).subscribe(() => {
      this.load();
    })
  }


  openControlItem() {

  }

  addPair(controlItem, complianceAreaId) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        except: [controlItem],
        complianceAreaId: complianceAreaId,
      }
    };


    const dialogRef = this.dialog.open(SelectControlItemComponent, config);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.broadcastControlItemId = controlItem.controlItemId;
        result.tenantName = this.tenantName;
        this.controlItemsService.update(result, this.tenantName).subscribe(() => {
          this.load();
        })
      }

    });
  }

  updateRowGroupMetaData() {
    const data = this.complianceArea.controlItems;
    this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }

  }

}
